import { cn } from '@compass/utils'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { GlobeLockIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const vpnDefinition: SmartSignalDefinition<{
  vpn?: IdEventV4['vpn']
  vpn_confidence?: IdEventV4['vpn_confidence']
  vpn_origin_timezone?: IdEventV4['vpn_origin_timezone']
  vpn_origin_country?: IdEventV4['vpn_origin_country']
  vpn_methods?: IdEventV4['vpn_methods']
}> = {
  key: 'vpn',
  label: 'VPN',
  extract: (e) => ({
    vpn: e.vpn,
    vpn_confidence: e.vpn_confidence,
    vpn_origin_timezone: e.vpn_origin_timezone,
    vpn_origin_country: e.vpn_origin_country,
    vpn_methods: e.vpn_methods,
  }),
  icon(e) {
    const p = this.extract(e)?.vpn
    return (
      <GlobeLockIcon
        size={16}
        className={cn({
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.vpn
    return p === true
  },
  isWeb: () => true,
  isMobile: () => true,
  searchFor: '"vpn":',
  documentationHash: '#vpn-detection-for-browsers',
  urlParamKey: IdentificationUrlKeys.Vpn,
}
